import tipoDispositivoService from '../../services/tipoDispositivoService'

const TipoDispositivoStore = {
  namespaced: true,
  state: {
    tipos: [],
  },
  getters: {
    tipos: (state) => state.tipos,
    tiposAsOptions: (state) =>
      state.tipos.map((t) => ({ value: t.id, text: t.nombre })),
  },
  mutations: {
    SET_TIPOS(state, tipos) {
      state.tipos = tipos
    },
  },
  actions: {
    async fetchTipos({ commit }) {
      const data = await tipoDispositivoService.list()
      commit('SET_TIPOS', data)
      return data
    },
  },
}

export default TipoDispositivoStore
